module.exports = __webpack_public_path__ + "static/TT1394_TW-MARK-D01_r1-clean-33cdeb85c9047ecaee9d0619d0274459.png";